import { useSelector } from "react-redux";
import { selectCurrent } from "../../../../../../../redux/settings/selectors";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../../hooks/hooks";
import Table from "../../../../../../../common/components/table";
import { useNavigate } from "react-router-dom";
import { selectLeadsListItems } from "../../../../../../../redux/leads/selector";
import { leads } from "../../../../../../../redux/leads/action";
import PageLoader from "../../../../../../../components/PageLoader";
import useWindowDimensions from "../../../../../../../hooks/useWindowsDimensions";
import MobileViewTable from "../../../../../../../common/components/mobile-view-table.component";

const CustomerLeads = () => {
  const dispatch = useAppDispatch()
  const { height, width } = useWindowDimensions();
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const itemsData = useSelector(selectLeadsListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },

      { field: 'Message.LeadInfo.Email', headerName: 'Email' },
      { field: 'Message.LeadInfo.PhoneNumber', headerName: 'Phone', sortable: true, filter: true },
      { field: 'Message.LeadInfo.start.location.address.building', headerName: 'From Address' },
      { field: 'Message.LeadInfo.end.location.address.building', headerName: 'To Address' },
      { field: 'Message.CreatedOnUtc', headerName: 'CreatedOn', isDateValueFormat: true },
      { field: 'Message.ModifiedOnUtc', headerName: 'ModifiedOn', isDateValueFormat: true },
    ]);
  }

  const fetchLeads = () => {
    dispatch(leads.list({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads/list`, entity: 'leads', jsonData: {
        "PageNumber": pageData,
        "PageSize": pageSize,
        "SortField": "Id",
        "SortOrder": "desc",
      }
    }))
  }
  const handleDelete = (data: any) => {
    dispatch(leads.delete({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads/delete`,
      entity: 'leads',
      jsonData: {
        Records: [
          {
            Context: {},
            Message: {
              Id: data?.Message?.Id
            }

          }
        ]
      }
    })).then(() => {
      dispatch(leads.list({
        url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads/list`, entity: 'leads', jsonData: {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "Id",
          "SortOrder": "desc",
        }
      }))
    });
  }
  useEffect(() => {
    createColumnDefs()
    fetchLeads()

  }, [pageData, pageSize])
  const handleEdit = (data: any) => {
    navigate(`${data?.Message?.Id}`)
  }

  return (
    <>
      {itemsData?.isLoading ? <PageLoader />
        :
        <>

          <Table columnData={columnDefs} rowData={itemsData?.result?.items} onEdit={handleEdit} setPageSize={setPageSize}
            setPageData={setPageData} paginationData={itemsData?.result?.pagination} onDelete={handleDelete} headingName="Leads" />
        </>

      }
    </>



  );
};

export default CustomerLeads;


